// extracted by mini-css-extract-plugin
export default {"welcome":"Welcome_welcome__V60sa","welcomeIcon":"Welcome_welcomeIcon__z+MU-","welcomeText":"Welcome_welcomeText__ELJ5U"};